<template>
    <div class="recipe-name">
        <svg version="1.0" encoding="UTF-8" viewBox="-250 -50 500 60" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <linearGradient :id="'rainbow' + _uid" x1="-200" x2="200" y1="0" y2="0" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F0DC28" offset="0%"/>
                    <stop stop-color="#F09910" offset="25%"/>
                    <stop stop-color="#D13260" offset="50%"/>
                    <stop stop-color="#50B9A0" offset="75%"/>
                    <stop stop-color="#AAB41E" offset="100%"/>
                </linearGradient>
            </defs>
            <text text-anchor="middle" :fill="'url(#rainbow' + _uid + ')'"></text>
        </svg>
    </div>
</template>

<script>
  export default {
    name: 'RainbowTitle',
    props: {
      title: {
        type: String
      },
      rowLength: {
        type: Number,
        default: 460
      },
      fontSize: {
        type: Number,
        default: 50
      }
    },
    computed: {
      titleText: function () {
        return this.title
      }
    },
    data: function () {
      return {
        svgText: '',
        svgNs: 'http://www.w3.org/2000/svg'
      }
    },
    mounted () {
      this.svg = this.$el.querySelector('svg')
      this.svgText = this.$el.querySelector('svg text')
      this.renderTitle()
    },
    methods: {
      renderTitle: function () {
        if (this.titleText === undefined)
          return

        // remove existing tspan elements
        for (let i = this.svgText.childNodes.length - 1; i >= 0; i--)
          this.svgText.removeChild(this.svgText.childNodes.item(i))

        // seperate words
        var words = this.titleText.split(' ')
        var tspanElement = document.createElementNS(this.svgNs, 'tspan')

        // add word to line
        var textNode = document.createTextNode(words[0])
        tspanElement.setAttribute('x', 0)
        tspanElement.setAttribute('y', 0)
        tspanElement.setAttribute('font-size', this.fontSize)
        tspanElement.appendChild(textNode)
        this.svgText.appendChild(tspanElement)

        for (let i = 1; i < words.length; i++) {
          var len = tspanElement.firstChild.data.length  // Find number of letters in string
          tspanElement.firstChild.data += ' ' + words[i] // Add next word

          // check if current line is to long
          if (tspanElement.getComputedTextLength() > this.rowLength) {
            tspanElement.firstChild.data = tspanElement.firstChild.data.slice(0, len)    // Remove added word

            var tspanElement = document.createElementNS(this.svgNs, 'tspan')
            tspanElement.setAttribute('x', 0)
            tspanElement.setAttribute('dy', this.fontSize)
            tspanElement.setAttribute('font-size', this.fontSize)
            textNode = document.createTextNode(words[i])
            tspanElement.appendChild(textNode)
            this.svgText.appendChild(tspanElement)
          }
        }

        // calculate height
        var svgHeight = this.svgText.childNodes.length * (this.fontSize + 5)

        // set height (min height 25)
        // this.svg.setAttribute('viewBox', '-250 -60 100 120');
        this.svg.setAttribute('viewBox', '-250 -50 500  ' + (svgHeight < 80 ? 80 : svgHeight))
      }
    }
  }
</script>
